import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router'
import {IntegrationNs} from '@shared/types'
import {useIntegrationStore} from "@domains/settings/stores/integration.store";
import {toast} from '@shared/ms-components'

export const confirmJiraAuthenticationResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {
    const payload = {
        authCode: to.query.code,
        state: to.query.state,
        integrationType: IntegrationNs.IntegrationTypeEnums.JIRA
    } as IntegrationNs.ConfirmAuthenticationRequest
    const intStore = useIntegrationStore();
    intStore.confirmAuthentication(payload).then(() => {
        toast.success('Authentication successful');

        next({path: '/settings/integrations/jira'})
    }).catch(() => {
        toast.error('Authentication unsuccessful')

        next({path: '/settings/integrations'})
    })
}
